/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from "react";
import SigninDetails from "./SigninDetails";
import { Outlet } from "react-router-dom";

export const ChangePasswordContext = React.createContext<any>(null);

const Signin = () => {
    const [mailAccount, setMailAccount] = useState("");
    const [otp, setOtp] = useState("");
    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [loginUsername, setLoginUsername] = useState("");
    const [loginPassword, setLoginPassword] = useState("");


    const contextValue = {
        mailAccount, setMailAccount, otp, setOtp, name, setName, username, setUsername,loginUsername, setLoginUsername,
        loginPassword, setLoginPassword
    };

    const memoizedContextValue = useMemo(() => contextValue, [
        mailAccount, setMailAccount, otp, setOtp, name, setName, username, setUsername,loginUsername, setLoginUsername,
        loginPassword, setLoginPassword
    ]);

    return (
        <div className="signin-wrapper h-screen md:flex bg-gradient-to-br from-primary-600 via-primary to-primary">
            <ChangePasswordContext.Provider value={memoizedContextValue}>
                <div className="flex-1 md:min-h-screen p-[30px] h-full flex justify-center items-center bg-white">
                    <Outlet />
                </div>
                <div className="flex-1 row-start-2 md:row-start-1 p-[30px] md:flex justify-center items-center hidden ">
                    <SigninDetails />
                </div>
            </ChangePasswordContext.Provider>
        </div>
    );
};

export default Signin;
